import { CardContentBox } from "../../profile/components/CardElements"
import { LocalizedEnum, LocalizedStrict } from "../../localization/components/AppLocalized"
import { MenuItem, Select, SelectChangeEvent, Stack, Typography } from "@mui/material"
import { useLocaleSelect } from "../../localization/localizationHooks"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    selectWrap: {
        minWidth: "13.75rem",
    },
    selectTitle: {
        fontWeight: 400,
        color: theme.palette.text.secondary,
    },
}))

export function UserLanguageCard() {
    const { classes } = useStyles()

    const { supportedLocales, selectedLocale, selectLocale } = useLocaleSelect()

    function handleLocaleChange(event: SelectChangeEvent<string>) {
        selectLocale(event.target.value)
    }

    return (
        <CardContentBox
            title={
                <LocalizedStrict id="profile-settings-card">
                    <>Settings</>
                </LocalizedStrict>
            }
        >
            <Stack alignItems="center" direction="row" justifyContent="space-between">
                <LocalizedStrict id="settings-language-setting">
                    <Typography>Language</Typography>
                </LocalizedStrict>
                <Select
                    value={selectedLocale}
                    onChange={handleLocaleChange}
                    size="medium"
                    className={classes.selectWrap}
                >
                    {supportedLocales.map((locale) => (
                        <MenuItem key={locale} value={locale}>
                            <LocalizedEnum base="language-selector-lang" enumValue={locale}>
                                <Typography variant="subtitle1" className={classes.selectTitle}>
                                    locale
                                </Typography>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </Stack>
        </CardContentBox>
    )
}
